import React, { createContext, useContext, useState, useEffect } from 'react';
import type { Student } from '../types';
import { authAPI } from '../lib/studentAPI';

interface AuthContextType {
  student: Student | null;
  isAuthenticated: boolean;
  login: (token: string, student: Student) => void;
  logout: () => void;
}

const AuthContext = createContext<AuthContextType | undefined>(undefined);

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [student, setStudent] = useState<Student | null>(null);

  useEffect(() => {
    const savedStudent = authAPI.getCurrentStudent();
    if (savedStudent) {
      setStudent(savedStudent);
    }
  }, []);

  const login = (token: string, studentData: Student) => {
    authAPI.saveAuth(token, studentData);
    setStudent(studentData);
  };

  const logout = () => {
    authAPI.logout();
    setStudent(null);
  };

  return (
    <AuthContext.Provider
      value={{
        student,
        isAuthenticated: !!student,
        login,
        logout,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};
